import {
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Table,
} from "@mui/material";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import HOST_URL from "../../../utils/Url";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import Autocomplete from "@mui/material/Autocomplete";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import FormControl from "@mui/material/FormControl";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast } from "react-toastify";
import dayjs from "dayjs";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import ToastApp from "../../../ToastApp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
type Props = {};
// CaseCategory

const selectOption = [
  { value: 1, label: "Antenna-1" },
  { value: 2, label: "Antenna-2" },
  { value: 3, label: "Antenna-3" },
  { value: 4, label: "Antenna-4" },
  { value: 5, label: "Antenna-8" },
];


const IssueReturn = (props: Props) => {
  return (
    <div
      style={{
        padding: "-5px 5px",
        backgroundColor: "#ffffff",
        borderRadius: "5px",
        marginTop: "3vh",
        border: ".5px solid #FF7722",
      }}
    >
      <CardContent>
        <Typography
          variant="h5"
          textAlign="center"
          style={{ fontSize: "18px", fontWeight: 500 }}
        >
          Library
        </Typography>

        {/* <Grid item sm={4} xs={12}>
        
          </Grid> */}

        <Divider />
        <br />

        <form>
        <Grid item xs={12} sm={12} container spacing={2}>
        <Grid item xs={12} container spacing={2}>


        <Grid xs={12} sm={4} item>
                <FormControl
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 10,
                    // marginTop: "13px",
                  }}
                >
                  <Grid>
                    <FormLabel>Process Used by RFID</FormLabel>
                  </Grid>
                  <Grid>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="row-radio-buttons-group"
                      // value={formik.values.rateIsFixed ? "Yes" : "No"}
                      onChange={(event) => {
                        // const isActive = event.target.value === "Yes";
                        // console.log(isActive);
                   }}
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio />}
                        label="No"
                      />
                    </RadioGroup>
                  </Grid>
                </FormControl>
              </Grid>


<Grid xs={6} sm={4} item>
<Autocomplete
                                    disablePortal
                                    // id={`combo-box-${row.id}`}
                                    options={selectOption}
                                    fullWidth
                                    size="small"
                                      //  value={RateTypeOption.find((option:any) => option.value === row.rateType) || null}

                                    // onChange={(event, newValue: any) => {
                                    //   // setTableRateType(newValue?.value);
                                    //   handleInputChange( row.id, "rateType", newValue?.value   );
                              
                                    // }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        label={<span>Select Antenna {""}</span>}
                                      />
                                    )}
                                  />
</Grid>

{/* scan */}

  <Grid sm={1} item>
                      <Button
                        variant="contained"
                        style={{
                          marginBottom: 15,
                          backgroundColor: "info",
                        }}
                        // onClick={addRow}
                      >
                     scan
                      </Button>
                    </Grid>
           


</Grid>




            <Grid item xs={12} sm={12} container spacing={4}>




            {/* Member */}
            <Grid item lg={4} xs={12}>
              <TextField
                label="Member ID"
                placeholder="Member ID"
                size="small"
                fullWidth
                //  onChange={}
              />
 </Grid>
             {/* button */}
             <Grid sm={1} item>
                      <Button
                        variant="contained"
                        style={{
                          marginBottom: 15,
                          backgroundColor: "info",
                        }}
                        // onClick={addRow}
                      >
                      Enter
                      </Button>
                    </Grid>
           


            {/*Acc.No.	  */}
            <Grid item lg={4} xs={12}>
              <TextField
                label="Acc.No.	"
                placeholder="Acc.No."
                size="small"
                fullWidth
                //  onChange={}
              />
            </Grid>
            {/* button */}
            <Grid sm={1} item>
                      <Button
                        variant="contained"
                        style={{
                          marginBottom: 15,
                          backgroundColor: "info",
                        }}
                        // onClick={addRow}
                      >
                      Enter
                      </Button>
                    </Grid>
          </Grid>

{/*  Member Details */}
<Grid xs={12} sm={12} item style={{ marginBottom: "10px" }}>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ backgroundColor: "#E2DFD2", color: "#1c1124" }}
                  >
                    <Typography style={{ fontWeight: 600, fontSize: "16px" }}>
                    Member Details
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={2}
                      sx={{ marginTop: "5px" }}
                    >
       <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                        <TextField
                          // value={formik.values.applicationFees}
                          // id="applicationFees"
                          // name="applicationFees"
                          type="text"
                          label="  Member Name"
                          placeholder="  Member Name"
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>

                  
                      <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                   <TextField
                          type="text"
                          label="Department"
                          placeholder="Department"
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>

                      <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                   <TextField
                          type="text"
                          label=" Member Group"
                          placeholder=" Member Group"
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>
                      <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                   <TextField
                  type="text"
                          label="Issue Limit"
                          placeholder="Issue Limit"
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>
                      <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                   <TextField
                          type="text"
                          label=" Course/ Designation"
                          placeholder=" Course/ Designation"
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>

                      <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                   <TextField
                 type="text"
                          label="Already Issued"
                          placeholder="Already Issued"
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>
                      <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                   <TextField
                type="text"
                          label="Issue Days"
                          placeholder="Issue Days"
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>

                      <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                   <TextField
                 type="text"
                          label=" Accession No."
                          placeholder=" Accession No."
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>
  {/* button */}
  <Grid item xs={12} container spacing={2}  alignItems="center" justifyContent="center"  >
        <Grid item lg={1} sm={1} xs={1}>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: "#059669",
                      color: "white",
                      marginTop: "10px",
                    }}
                  >
           Save
                  </Button>
                </Grid>
                </Grid>





                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <br />
              </Grid>


{/* File Details */}
{/*  Member Details */}
<Grid xs={12} sm={12} item style={{ marginBottom: "10px" }}>
                <Accordion>
                  <AccordionSummary
                    expandIcon={<ArrowDropDownIcon />}
                    aria-controls="panel2-content"
                    id="panel2-header"
                    sx={{ backgroundColor: "#E2DFD2", color: "#1c1124" }}
                  >
                    <Typography style={{ fontWeight: 600, fontSize: "16px" }}>
                    File Details
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid
                      item
                      xs={12}
                      container
                      spacing={2}
                      sx={{ marginTop: "5px" }}
                    >
       <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                        <TextField
                          // value={formik.values.applicationFees}
                          // id="applicationFees"
                          // name="applicationFees"
                          type="text"
                          label="File No."
                          placeholder="File No."
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>

                  
                      <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                   <TextField
                          type="text"
                          label="Department"
                          placeholder="Department"
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>

                      <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                   <TextField
                          type="text"
                          label=" Member Group"
                          placeholder=" Member Group"
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>
                      <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                   <TextField
                  type="text"
                          label="Issue Limit"
                          placeholder="Issue Limit"
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>
                      <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                   <TextField
                          type="text"
                          label=" Course/ Designation"
                          placeholder=" Course/ Designation"
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>

                      <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                   <TextField
                 type="text"
                          label="Already Issued"
                          placeholder="Already Issued"
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>
                      <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                   <TextField
                type="text"
                          label="Issue Days"
                          placeholder="Issue Days"
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>

                      <Grid xs={12}  sm={4}  item  style={{ marginBottom: "10px" }}>
                   <TextField
                 type="text"
                          label=" Accession No."
                          placeholder=" Accession No."
                          size="small"
                          fullWidth
                          style={{ backgroundColor: "white" }}
                        />
                      </Grid>
  {/* button */}
  <Grid item xs={12} container spacing={2}  alignItems="center" justifyContent="center"  >
        <Grid item lg={1} sm={1} xs={1}>
                  <Button
                    type="submit"
                    fullWidth
                    style={{
                      backgroundColor: "#059669",
                      color: "white",
                      marginTop: "10px",
                    }}
                  >
           Save
                  </Button>
                </Grid>
                </Grid>

{/* table details */}
<Grid container xs={12} spacing={2}>
                    <Grid xs={12} sm={12} item>
                      <Table
                        style={{
                          borderCollapse: "collapse",
                          width: "100%",
                          border: "1px solid black",
                          marginLeft: "20px",
                        }}
                      >
                        <thead
                          style={{
                            backgroundColor: "#2196f3",
                            color: "#f5f5f5",
                          }}
                        >
                          <tr>
                            <th
                              style={{
                                borderLeft: "1px solid black",
                                paddingBlock: "10",
                                paddingTop: "5px",
                                paddingBottom: "5px",
                              }}
                            >
                            Member Name
                            </th>

                            <th
                              style={{
                                borderLeft: "1px solid black",
                                paddingTop: "5px",
                                paddingBottom: "5px",
                              }}
                            >
                     Department
                            </th>
                            <th
                              style={{
                                borderLeft: "1px solid black",
                                paddingTop: "5px",
                                paddingBottom: "5px",
                              }}
                            >
                         Member Group
                            </th>

                            <th
                              style={{
                                borderLeft: "1px solid black",
                                paddingTop: "5px",
                                paddingBottom: "5px",
                              }}
                            >
                         Course/ Designation
                            </th>
                            <th
                              style={{
                                borderLeft: "1px solid black",
                                paddingTop: "5px",
                                paddingBottom: "5px",
                              }}
                            >
                   Issue Limit
                            </th>
                            <th
                              style={{
                                borderLeft: "1px solid black",
                                paddingTop: "5px",
                                paddingBottom: "5px",
                              }}
                            >
                   	Already Issued
                            </th>

                            <th
                              style={{
                                borderLeft: "1px solid black",
                                paddingTop: "5px",
                                paddingBottom: "5px",
                              }}
                            >
                  Issue Days
                            </th>
                     
                            <th
                              style={{
                                borderLeft: "1px solid black",
                                paddingTop: "5px",
                                paddingBottom: "5px",
                              }}
                            >
                 Accession No.
                            </th>
                          </tr>
                        </thead>
                     {/* <tbody style={{ border: "1px solid black" }}>
                          {tableData.map((row: any, index: any) => (
                            <tr
                              key={row.id}
                              style={{ border: "1px solid black" }}
                            >
                              <td
                                style={{
                                  borderLeft: "1px solid black",
                                  borderTop: "1px solid black",
                                  textAlign: "center",
                                }}
                              >
                                {row.isEditing ===false ? (
                                  <EditIcon
                                    style={{
                                      fontSize: "20px",
                                      color: "blue",
                                      cursor: "pointer",
                                      marginRight: "10px",
                                    }}
                                    onClick={() => editRow(row.id)}
                                  />
                                ) : (
                                  <SaveIcon
                                    style={{
                                      fontSize: "20px",
                                      color: "green",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => saveChanges(row.id)}
                                  />
                                )}
                                <DeleteIcon
                                  style={{
                                    fontSize: "20px",
                                    color: "red",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => removeRow(row.id)}
                                />
                              </td>
                               <td
                                style={{
                                  borderLeft: "1px solid black",
                                  borderTop: "1px solid black",
                                  textAlign: "center",
                                }}
                              >
                                {row.isEditing ? (
                                  <TextField
                                    size="small"
                                    fullWidth
                                    type="Date"

                                    value={row.effectiveDate}
                                    onChange={(e) =>
                                      handleInputChange(
                                        row.id,
                                        "effectiveDate",
                                        e.target.value
                                      )
                                    }
                                  />
                                ) : (
                                  row.effectiveDate
                                )}
                              </td>
                              
                              <td
                                style={{
                                  borderLeft: "1px solid black",
                                  borderTop: "1px solid black",
                                  textAlign: "center",
                                }}
                              >
                                {row.isEditing ? (
                                  <TextField
                                    size="small"
                                    fullWidth
                                    type="text"
                                    value={row.rate}
                                    onChange={(e) =>
                                      handleInputChange(
                                        row.id,
                                        "rate",
                                        e.target.value
                                      )
                                    }
                                  />
                                ) : (
                                  row.rate
                                )}
                              </td>

                          
                            </tr>
                          ))}
                        </tbody> */}
                      </Table>
                    </Grid>
                  </Grid>


                
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                <br />
              </Grid>




              </Grid>
              </form>
         
          </CardContent>
    </div>
  );
};

export default IssueReturn;
